import styled from 'styled-components';
import { RootPortal } from '../../common/RootPortal';
import { MODAL_TYPE } from '../../../store/modalStore';
import { useTextVariant } from '../../../hook/useTextVariant';
import { COMMON_MODAL_CONSTANTS } from '../../../constants/commonModal';
import { CommonModalViewProps } from '../CommonModal';

export const CommonModalPc = ({
  isVisibleCommon,
  modalType,
  notStartText,
  onConfirm,
}: CommonModalViewProps) => {
  const { getText } = useTextVariant(COMMON_MODAL_CONSTANTS, false);

  return (
    <RootPortal>
      <ModalWrap $visible={isVisibleCommon}>
        <Dim />
        <ModalContent $visible={isVisibleCommon}>
          <Content>
            {modalType === MODAL_TYPE.NOT_START && <ContentText>{notStartText}</ContentText>}
            {modalType === MODAL_TYPE.CHECK_TICKET && (
              <ContentText>{getText('checkTicket')}</ContentText>
            )}
            {modalType === MODAL_TYPE.IS_AGREE_PRIVACY && (
              <ContentText>{getText('isAgreePrivacy')}</ContentText>
            )}
            {modalType === MODAL_TYPE.REAL_NOT_AGREE && (
              <ContentText>{getText('realNotAgreeText')}</ContentText>
            )}
            {modalType === MODAL_TYPE.CHECK_AGREE && (
              <ContentText>{getText('checkAgree')}</ContentText>
            )}
            {modalType === MODAL_TYPE.COMPLETE_AGREE && (
              <ContentText>{getText('completeAgree')}</ContentText>
            )}
            {(modalType === MODAL_TYPE.CHECK_AGREE || modalType === MODAL_TYPE.COMPLETE_AGREE) && (
              <CheckTournamentText>{getText('checkTournamentText')}</CheckTournamentText>
            )}
          </Content>

          {modalType !== MODAL_TYPE.REAL_NOT_AGREE && (
            <ButtonContainer onClick={onConfirm}>
              <ConfirmButton>{getText('confirmBtn')}</ConfirmButton>
            </ButtonContainer>
          )}
        </ModalContent>
      </ModalWrap>
    </RootPortal>
  );
};

const ConfirmButton = styled.button`
  width: 130px;
  height: 46px;
  border-radius: 25px;
  background: #5200d3;
  box-shadow:
    0 -1px 0 0 rgba(104, 104, 104, 0.3) inset,
    0 2px 0 0 rgba(0, 0, 0, 0.15),
    0 1px 1px 0 rgba(173, 166, 153, 0.5) inset;
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -1.2px;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;

  &:active {
    transform: translateY(2px) scale(0.97);
    box-shadow:
      0 -1px 0 0 rgba(104, 104, 104, 0.3) inset,
      0 0px 0 0 rgba(0, 0, 0, 0.15),
      0 1px 1px 0 rgba(173, 166, 153, 0.5) inset;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  height: 74px;

  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 0px 0px 20px 20px;
  background: #222120;
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  width: 90%;
  max-width: 420px;
  max-height: 80%;
  background: #302e2d;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;

  box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.3) inset;
`;

const Content = styled.div`
  height: 156px;
  border-radius: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.3px;
`;

const CheckTournamentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px; /* 120% */
`;
